module.exports = __webpack_public_path__ + "img/02@2x.36d30492.png";